import { Injectable } from '@angular/core';
import { ApiBaseService } from './api.base.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class documentServices extends ApiBaseService {
    constructor(public http: HttpClient) {
        super(http, '/documents');
    }
    checkNameExists(name: string, id?: boolean | number): Observable<any> {
        const documentId = id ? id : null;
        const params = { name, documentId };
        return this.http.get(`${environment.apiUrl}/documents/check`, {
            params,
        });
    }

    postDocument(data:any,token?:any){
        if(token){
            return this.http.post(`${environment.apiUrl}/external/documents`,data)
        }else{
            return this.http.post(`${environment.apiUrl}/documents/upload`,data)
        };
    }

    deleteApplication(applicationId: number): Observable<any> {
        return this.http.delete(`${environment.apiUrl}/applications/${applicationId}`);
    }



    generateLink(data:any){
        return this.http.post(`${environment.apiUrl}/documents/generateLink`,data);
    }

    generateDocuments(params:any){
        if(params.token){
            return this.http.get(`${environment.apiUrl}/external/lead_document`, {
                params,
            });
        }else{
            return this.http.get(`${environment.apiUrl}/documents/lead_document`, {
                params,
            });
        };
    }
}
